<template>
  <div class="detail-rows">
    <div class='table-content atb-flex atb-flex-column'>
      <vxe-table class='atb-table header-table edit-table' border='inner' height='100%' auto-resize resizable stripe
        highlight-hover-row highlight-current-row :data="tableData" @cell-click="expandRow" ref="tableEl">
        <vxe-table-column type='seq' width='55' align='center' title="序号"></vxe-table-column>
        <vxe-table-column field="resWkName" title="指定人" width="140">
          <template #default="{ row }">
            <span>{{ row.resWkName }}({{ row.resWkNo }})</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="status" title="提交状态" width="135" show-overflow>
          <template #default="{ row }">
            <el-tag v-if='row.status === 0' type="complete" effect="dark">
              已保存
            </el-tag>
            <el-tag v-if='row.status === 10' type="delay" effect="dark">
              已提交-未审核
            </el-tag>
            <el-tag v-if='row.status >= 20 && row.status !== 30' type="complete" effect="dark">
              发布完成
            </el-tag>
            <el-tag v-if='row.status === 30' type="close" effect="dark">
              已驳回
            </el-tag>
          </template>
        </vxe-table-column>
        <vxe-table-column field="approveReason" title="审批意见" width="130">
          <template #default="{ row }">
            <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.approveReason|| '无'}}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="opera" title="操作" width='120' class-name='operation'>
          <template #default="scope">
            <div v-if='scope.row.status === 0 || scope.row.status === 30'>
              <el-tooltip class='item' effect='dark' content='发布' placement="bottom">
                <i class='icon-send' @click.stop='send({row:scope.row})'></i>
              </el-tooltip>
              <el-tooltip class='item' effect='dark' content='删除' placement="bottom">
                <i class='icon-close delete' @click.stop='deleteTip({row:scope.row})'></i>
              </el-tooltip>
            </div>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column field="workItemContent" title="工作项目" width="130">
          <template #default="{ row }">
            <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">
              {{ row.workItemContent }}
            </div>
          </template>
        </vxe-table-column> -->
        <vxe-table-column field="weight" title="权重" width="80"></vxe-table-column>
        <vxe-table-column field="fullTarget" title="总目标" min-width="160">
          <template #default="{ row }">
            <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.wholeTarget }}</div>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class='page-con atb-flex atb-flex-justify-end'>
      <vxe-pager
        background
        :current-page.sync="pageIndex"
        :page-size.sync="pageSize"
        :total="total"
        height="100%"
        @page-change="handledPageChange"
        pager-count="4"
        :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
      >
      </vxe-pager>
    </div>
    <el-dialog title="提示" :visible.sync="showDelTip" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定要删除吗</h2>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="del">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showDelTip = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import XEUtils from 'xe-utils';
  export default {
    name: 'RowDetail',
    props: {
      rowData: Object,
      workClassifyList: Array,
    },
    data() {
      return {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
        tableData: [],
        showDelTip: false,
        currDelRow: {},
      }
    },
    watch: {
      rowData: {
        handler(newVal) {
          this.pageIndex = 1;
          this.total = newVal.resWks.length;
          this.setTableData();
        },
        immediate: true,
      }
    },
    created() {
      
    },
    methods: {
      formatDate(value, format) {
        return XEUtils.toDateString(value, format);
      },
      expandRow({rowIndex}) {
        this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
        this.$refs.tableEl.updateData(this.tableData);
      },
      handledPageChange() {
        this.setTableData();
      },
      setTableData() {
        const rows = this.rowData.resWks || [];
        this.tableData = rows.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize);
      },
      send({row}){
        this.$ajax.put(this.$api.add.PublishMonthWork.commitWorkItem, `"${row.id}"`, { headers: { 'Content-Type': 'application/json;charset=UTF-8;' } }).then((res) => {
          if(res.code === 0){
            this.$message.success('发布成功');
            // this.getList(1);
            row.status = res.data.status;
            let completeTotal = 0;
            this.rowData.resWks.forEach(item => {
              if (![0, 30].includes(item.status)) {
                this.rowData.totalStatus = -1;
              }
              if (item.status === 20) {
                completeTotal++;
              }
            })
            if (completeTotal === this.rowData.resWks.length) {
              this.$emit('allPublishComplete');
            }
          }
        });
      },
      deleteTip({row}) {
        if (this.rowData.resWks.length === 1 && [0, 30].includes(row.status)) {
          this.$emit('deleteWorkItem');
        } else {
          this.showDelTip = true;
          this.currDelRow = row;
        }
      },
      del() {
        let apiStr = this.$api.add.PublishMonthWork.batchAdd;
        let detailResWkInfos = this.rowData.resWks.filter(item => item.id !== this.currDelRow.id);
        const params = {
          ...this.rowData,
          detailResWkInfos: detailResWkInfos,
          resWks: undefined,
          publishType: this.rowData.publishType.toString(),
        }
        this.$ajax.post(apiStr, params).then(res=>{
          if (res.code === 0){
            this.$message.success('删除成功');
            this.$emit('submitSuccess');
            this.rowData.resWks.splice(this.rowData.resWks.findIndex(item => item.id === this.currDelRow.id), 1);
            this.pageIndex = 1;
            this.setTableData();
            let completeTotal = 0;
            let isReject = true;
            this.rowData.resWks.forEach(item => {
              isReject = isReject && item.status === 30;
              if (![0, 30].includes(item.status)) {
                this.rowData.totalStatus = -1;
              }
              if (item.status === 20) {
                completeTotal++;
              }
            })
            if (isReject) this.rowData.totalStatus = 30;
            if (completeTotal === this.rowData.resWks.length) {
              this.$emit('allPublishComplete');
            }
          }
        }).finally(()=>{
          this.showDelTip=false;
        });
      },
    }
  }
</script>
<style scoped lang='scss'>
.detail-rows {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.page-con {
  flex: 0 0 56px;
}
</style>